// 💡 기본 axios가 아닌, baseURL 환경변수가 적용된 axiosInstance를 불러옵니다.
// (경로는 실제 axiosInstance.ts 파일이 있는 위치에 맞게 맞춰주세요. 예: './axiosInstance' 또는 '@/api/axiosInstance')
import { axiosInstance } from './axiosInstance';

export const getS3PresignedUrl = async (filename: string, folder: string = "products") => {
    try {
        // 💡 axios.get -> axiosInstance.get 으로 변경!
        // const response = await axiosInstance.get(`/api/s3/presigned-url?filename=${encodeURIComponent(filename)}`);
        // params에 folder도 함께 넘겨줍니다.
        const response = await axiosInstance.get(`/api/s3/presigned-url`, {
            params: { filename, folder }
        });

        // ApiResponse 구조에 맞게 데이터 반환 (status, message, data 구조라고 가정)
        if (response.data && response.data.data) {
            return response.data.data; // { presignedUrl: "...", imageUrl: "..." }
        }

        // 만약 백엔드에서 data 껍데기 없이 바로 반환하는 경우를 대비한 방어 로직
        if (response.data && response.data.presignedUrl) {
            return response.data;
        }

        throw new Error("Presigned URL 발급 실패 (응답 데이터 구조 불일치)");
    } catch (error) {
        console.error("S3 URL 발급 에러:", error);
        throw error;
    }
};

export const deleteS3Image = async (imageUrl: string) => {
    try {
        await axiosInstance.delete(`/api/s3/delete?imageUrl=${encodeURIComponent(imageUrl)}`);
    } catch (error) {
        console.error("S3 이미지 삭제 에러:", error);
    }
};